import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { FeatureFlagService, PERFORMANCE_PAGE_ENABLED_FLAG_KEY } from './feature-flag.service';

/**
 * Gates `/pricing/performance` behind `performance-page-enabled`, falling back to
 * `environment.features.performancePage`. Mirrors `bandAdherenceEnabledGuard`; the
 * sidebar entry checks the same flag.
 */
export const performancePageEnabledGuard: CanActivateFn = async () => {
  const flags = inject(FeatureFlagService);
  const router = inject(Router);
  await flags.ready();
  return (
    flags.isEnabledWithFallback(
      PERFORMANCE_PAGE_ENABLED_FLAG_KEY,
      environment.features.performancePage
    ) || router.createUrlTree(['/pricing'])
  );
};
